import { Injectable } from '@angular/core';
import { ApiClientService } from 'projects/dnest-core-angular/src/public-api';
import { VeevaId } from 'src/app/models/veeva-id';

@Injectable({
  providedIn: 'root'
})
export class VeevaIdApiClientService extends ApiClientService<VeevaId> {
  endpoint = 'veeva';
}


